export type EpiCartProduct = {
    id: number;
    quantity: number;
};

export type CreateEpiOrderPayload = {
    operator_id: number;
    id_worksite: number;
    date_order: string;
    comment: string;
    products: EpiCartProduct[];
};

export type CreateEpiOrderResponse = {
    success: {
        code: number;
        message: string;
        key: string;
    };
};

export type UpdateEpiOrderPayload = {
    id: string;
    operator_id: number;
    id_worksite: number;
    date_order: string;
    comment: string;
    products: EpiCartProduct[];
};

export type UpdateEpiOrderResponse = {
    success: {
        code: number;
        message: string;
        key: string;
    };
};

export type DeleteEpiOrderPayload = {
    id: string;
};

export type DeleteEpiOrderResponse = {
    success: {
        code: number;
        message: string;
        key: string;
    };
};

export type EpiOrderProduct = {
    id: string;
    quantity: string;
    id_category: string;
    label: string;
    image: string;
    packing_unit: string;
    available: string;
};

export type EpiOrder = {
    id: string;
    id_operator: number;
    id_worksite: number;
    date_order: string;
    comment: string;
    status: EpiOrderStatuses;
    products: EpiOrderProduct[];
};

export type GetEpiOrdersResponse = EpiOrder[];

export enum EpiOrderStatuses {
    CREATED = '1',
    CONFIRMED = '2',
    VALIDATED = '3',
    DELETED = '4',
    FAVORITED = '5',
    SYNCHRONIZED = '6'
}
